export const transformHostInfoData = (data, backData) => {
  return data.map(item => {
    let newLabel = "";
    let newLabelStatus = false;
    if (item.id === "webRtcIps") {
      newLabel = backData[item.id]?.length > 0 ? backData[item.id] : "No";
    } else if (item.id === "blacklist_check") {
      newLabel = backData[item.id];
    } else {
      newLabel = backData[item.id] ? "Yes" : "No";
      newLabelStatus = !!backData[item.id];
    }

    return {
      ...item,
      label: newLabel,
      labelStatus: newLabelStatus,
      value: "",
    };
  });
};
